import type { PoDraftLineRow } from "./poDraftUtils";
import { inventoryIngredientsApi } from "../../api/client";

/** ຖ້າທຸກບັນທັດວັດຖຸດິບມີ default supplier ດຽວກັນ → ຄืນ supplier id */
export async function inferPoSupplierFromLines(
  lines: PoDraftLineRow[],
): Promise<string | null> {
  const ingredientIds = [
    ...new Set(
      lines
        .filter((l) => l.itemType === "INGREDIENT" && l.itemId)
        .map((l) => l.itemId),
    ),
  ];
  if (ingredientIds.length === 0) return null;

  const suppliers = new Set<string>();
  for (const id of ingredientIds) {
    try {
      const ing = await inventoryIngredientsApi.get(id);
      if (ing.defaultSupplierId) suppliers.add(ing.defaultSupplierId);
    } catch {
      continue;
    }
  }
  if (suppliers.size !== 1) return null;
  return [...suppliers][0] ?? null;
}
